import Link from "next/link";

import { Anchor, Button } from "@newsela/angelou";

import { MONOLITH_ORIGIN } from "@/monolithIntegration/monolithIntegration.constants";
import { anchorCss } from "./HomepageCta.style";

const HomepageCta = () => {
  return (
    <Link href={MONOLITH_ORIGIN} passHref legacyBehavior>
      <Anchor
        __cssFor={{ root: anchorCss }}
        styleAnchorAsButton={{
          flavor: Button.flavors.primary,
        }}
      >
        Visit homepage
      </Anchor>
    </Link>
  );
};

export default HomepageCta;
